module.exports = __webpack_public_path__ + "afd1fb750e8eb1a57d959d84a343af61.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/megaphone.png
// module id = 277
// module chunks = 0